import * as React from 'react';
import { render } from 'react-dom';
import { enableSentry } from '@websky/core/src/utils';
import { withConfig } from '@websky/core/src/config-hoc';
import merge from 'lodash.merge';
import { store } from '@websky/core/src/SearchForm/components/Component';
import { setLocation } from '@websky/core/src/SearchForm/store/segments/actions';
export const setIata = (iata, name, type) => {
    const MAX_TRIES = 20;
    let tryCount = 0;
    const interval = setInterval(() => {
        if (!store) {
            console.log('no store');
            tryCount += 1;
            return;
        }
        if (tryCount === MAX_TRIES) {
            clearInterval(interval);
        }
        clearInterval(interval);
        store.dispatch(setLocation({
            iata: iata,
            name: name,
            stopPointsCount: null,
            match: {
                type: 'Default',
                iata: null,
                distance: null,
                name: null,
                __typename: 'LocationMatch'
            },
            __typename: 'LocationInLocationGroup'
        }, type));
    }, 100);
};
enableSentry();
import SearchForm from './SearchForm';
import { config as defaultConfig } from '../../config';
export const init = (mount, config) => {
    const Component = withConfig(SearchForm, merge({}, defaultConfig, config));
    render(React.createElement(Component, null), mount);
};
